import { render, staticRenderFns } from "./CreateDelivery.vue?vue&type=template&id=382538de&"
import script from "./CreateDelivery.vue?vue&type=script&lang=js&"
export * from "./CreateDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CreateDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports